export default __webpack_public_path__ + "static/card-2-6aa16cbfdce8f73a9b9731c2385d3168.png";